import { ComponentProps, FC, useCallback, useMemo } from 'react';

import { CompositeSelectionChips as Chips } from 'components/common/CompositeSelection/components/Chips';
import { CompositeSelectionExcludedChips as ExcludedChips } from 'components/common/CompositeSelection/components/ExcludedChips';
import { CompositeSelectionTreeSelectorModal as TreeSelectorModal } from 'components/common/CompositeSelection/components/TreeSelectorModal';
import { CompositeSelectionContextProvider } from 'components/common/CompositeSelection/contexts';

type CompositeSelectionProps = Omit<ComponentProps<typeof CompositeSelectionContextProvider>, 'onChange'> & {
    onChange: (value: string[], excludedValue?: string[]) => void;
};

const CompositeSelection: FC<CompositeSelectionProps> = (props) => {
    const { collection, value, excludedValue, onChange, children } = props;

    const filteredValue = useMemo(() => {
        return [...new Set(value)];
    }, [value]);

    const handleChange = useCallback(
        (includedValue: string[], excludedValue?: string[]) => {
            const filteredIncludedValue = [...new Set(includedValue)];
            const filteredExcludedValue = [...new Set(excludedValue)];
            onChange(filteredIncludedValue, filteredExcludedValue);
        },
        [onChange]
    );

    return (
        <CompositeSelectionContextProvider
            collection={collection}
            value={filteredValue}
            excludedValue={excludedValue}
            onChange={handleChange}
        >
            {children}
        </CompositeSelectionContextProvider>
    );
};

export default {
    Root: CompositeSelection,
    TreeSelectorModal,
    Chips,
    ExcludedChips,
};
